import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Register } from '../../Service/authService';
import Swal from 'sweetalert2';
import Logo from '../../asserts/logo.jpeg'

const initialState = {
    username: '',
    password: '',
  };
const Registerpage = () => {

    const [formData, setFormData] = useState(initialState);
     const { username, password } = formData;
     const navigate = useNavigate();


     const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const registerUser = async(e) =>{
        e.preventDefault();
        try{
            const data = await Register(formData);
            console.log(data);
            if (data) {
                Swal.fire({
                    icon: 'success',
                    title: 'Register Successful!',
                    text: 'Welcomeeee...',
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    navigate('/');
                });
            }
        }catch (error) {
            console.log(error);
          }
      }


  return (
    <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <div>
                            <img className="img-fluid" src={Logo} alt="Logo" />

                            </div>
                            <h5 className="card-title mb-4 text-center">Register</h5>

                            <form onSubmit={registerUser}>
                                <div className="mb-3">
                                    <input type="text" className="form-control" placeholder="Username" name="username" value={username} onChange={handleInputChange} />
                                </div>
                                <div className="mb-3">
                                    <input type="password" className="form-control" placeholder="Password" name="password" value={password} onChange={handleInputChange} />
                                </div>
                                <div>
                                    <button type="submit" className="btn btn-primary">Register</button>
                                </div>
                                <div>
                                    <Link className='text-decoration-none' to={'/'}><p>Loging Account</p></Link>
                                </div>
                            </form>


                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Registerpage